// The per-user dashboard layout setting, shared by every app that mounts the Overview grid.
export enum DashboardAppSettingKeyEnum {
  DASHBOARD_LAYOUT = 'DASHBOARD_LAYOUT',
}
